// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__b9Kc+","button":"Badge_button__6EImU"};